import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer"
import React from "react"

// Define styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 15,
  },
  headerContainer: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  headerLeft: {
    width: "75%",
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  headerRight: {
    width: "25%",
  },
  headerSection: {
    padding: 5,
  },
  logo: {
    width: 80,
    height: 50,
    marginRight: 10,
  },
  companyDetails: {
    flexDirection: "row",
    padding: 5,
  },
  buyerSection: {
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  buyerInfo: {
    padding: 5,
  },
  row: {
    flexDirection: "row",
    marginBottom: 2,
  },
  label: {
    width: 80,
  },
  colon: {
    width: 10,
    textAlign: "center",
  },
  itemsTable: {
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableCell: {
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  siNoCell: {
    width: "5%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 4,
  },
  particularsCell: {
    width: "50%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 4,
  },
  hsnCell: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 4,
    textAlign: "center",
  },
  gstCell: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 4,
    textAlign: "center",
  },
  amountCell: {
    width: "20%",
    padding: 4,
    textAlign: "right",
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderTopWidth: 1,
    borderTopColor: "#000",
    padding: 4,
  },
  amountInWords: {
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
    marginBottom: 10,
  },
  taxTable: {
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  taxRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  taxHeaderCell: {
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 4,
    textAlign: "center",
  },
  bankDetails: {
    marginTop: 20,
  },
  signatureBox: {
    position: "absolute",
    bottom: 60,
    right: 20,
    width: 200,
    height: 80,
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
  },
})

const InvoicePDF = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>PROFORMA INVOICE</Text>

      <View style={styles.headerContainer}>
        <View style={styles.headerLeft}>
          <View style={styles.companyDetails}>
            <Image src={"/buillogo6.png"} style={styles.logo} />
            <View>
              <Text style={{ fontWeight: "bold" }}>Rising Phoenix Print Hub LLP</Text>
              <Text>B-56, Gururaj Society, Padamavati,</Text>
              <Text>Pune Satara Road, Pune-411037</Text>
              <Text>GSTIN/UIN: 27ABFR8690N1ZG</Text>
              <Text>State Name: Maharashtra, Code: 27</Text>
              <Text>Contact: 9824311586</Text>
              <Text>E-Mail: risemgz@gmail.com</Text>
            </View>
          </View>
        </View>
        <View style={styles.headerRight}>
          <View style={styles.headerSection}>
            <View style={styles.row}>
              <Text>Invoice No.</Text>
              <Text style={{ marginLeft: 5 }}>2024-25/PI-08</Text>
            </View>
            <View style={styles.row}>
              <Text>Dated</Text>
              <Text style={{ marginLeft: 5 }}>27-Dec-24</Text>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.buyerSection}>
        <View style={styles.buyerInfo}>
          <Text style={{ fontWeight: "bold", marginBottom: 5 }}>Buyer (Bill to)</Text>
          <Text>OGCS Private Limited</Text>
          <Text>Flat-K-204, Shivamchsgutn, 195 Hissa-A-2</Text>
          <Text>Vichumbe,Panvel, Chowk, Raigad</Text>
          <View style={styles.row}>
            <Text style={styles.label}>GSTIN/UIN</Text>
            <Text style={styles.colon}>:</Text>
            <Text>27AAEC01131F1ZW</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>PAN/IT No</Text>
            <Text style={styles.colon}>:</Text>
            <Text>AAEC01131F</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>State Name</Text>
            <Text style={styles.colon}>:</Text>
            <Text>Maharashtra, Code: 27</Text>
          </View>
        </View>
      </View>

      <View style={styles.itemsTable}>
        <View style={styles.tableHeader}>
          <Text style={styles.siNoCell}>SI No.</Text>
          <Text style={styles.particularsCell}>Particulars</Text>
          <Text style={styles.hsnCell}>HSN/SAC</Text>
          <Text style={styles.gstCell}>GST Rate</Text>
          <Text style={styles.amountCell}>Amount</Text>
        </View>
        <View style={{ flexDirection: "row" }}>
          <Text style={styles.siNoCell}>1</Text>
          <View style={styles.particularsCell}>
            <Text style={{ fontWeight: "bold" }}>Sales - Printing Charges (GST)18%</Text>
            <Text style={{ fontStyle: "italic" }}>Printing of Calenders</Text>
            <Text>Size 11*14.50</Text>
            <Text>7 Sheets</Text>
            <Text>Paper 100 GSM Art</Text>
            <Text>No of Copies 700 @ Rs 45/Copy</Text>
            <Text style={{ marginTop: 20 }}>Output CGST</Text>
            <Text>Output SGST</Text>
          </View>
          <Text style={styles.hsnCell}>998912</Text>
          <Text style={styles.gstCell}>18%</Text>
          <View style={styles.amountCell}>
            <Text>31,500.00</Text>
            <Text style={{ marginTop: 20 }}>2,835.00</Text>
            <Text>2,835.00</Text>
          </View>
        </View>
      </View>

      <View style={styles.totalRow}>
        <Text>Total</Text>
        <Text style={{ marginLeft: 20, marginRight: 5 }}>Rs</Text>
        <Text>37,170.00</Text>
        <Text style={{ position: "absolute", right: 5, top: 0 }}>E. & O.E</Text>
      </View>

      <View style={styles.amountInWords}>
        <Text>Amount Chargeable (in words)</Text>
        <Text style={{ fontWeight: "bold" }}>INR Thirty Seven Thousand One Hundred Seventy Only</Text>
      </View>

      <View style={styles.taxTable}>
        <View style={styles.taxRow}>
          <Text style={[styles.taxHeaderCell, { width: "20%" }]}>HSN/SAC</Text>
          <Text style={[styles.taxHeaderCell, { width: "20%" }]}>Taxable Value</Text>
          <View style={[styles.taxHeaderCell, { width: "30%" }]}>
            <Text>CGST</Text>
            <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 2 }}>
              <Text>Rate</Text>
              <Text>Amount</Text>
            </View>
          </View>
          <View style={[styles.taxHeaderCell, { width: "30%", borderRightWidth: 0 }]}>
            <Text>SGST/UTGST</Text>
            <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 2 }}>
              <Text>Rate</Text>
              <Text>Amount</Text>
            </View>
          </View>
        </View>
        <View style={styles.taxRow}>
          <Text style={[styles.taxHeaderCell, { width: "20%" }]}>998912</Text>
          <Text style={[styles.taxHeaderCell, { width: "20%" }]}>31,500.00</Text>
          <View style={[styles.taxHeaderCell, { width: "30%" }]}>
            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
              <Text>9%</Text>
              <Text>2,835.00</Text>
            </View>
          </View>
          <View style={[styles.taxHeaderCell, { width: "30%", borderRightWidth: 0 }]}>
            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
              <Text>9%</Text>
              <Text>2,835.00</Text>
            </View>
          </View>
        </View>
        <View style={[styles.taxRow, { borderBottomWidth: 0 }]}>
          <Text style={[styles.taxHeaderCell, { width: "20%" }]}>Total</Text>
          <Text style={[styles.taxHeaderCell, { width: "20%" }]}>31,500.00</Text>
          <Text style={[styles.taxHeaderCell, { width: "30%" }]}>2,835.00</Text>
          <Text style={[styles.taxHeaderCell, { width: "30%", borderRightWidth: 0 }]}>2,835.00</Text>
        </View>
      </View>

      <Text style={{ marginBottom: 10 }}>Tax Amount (in words) : INR Five Thousand Six Hundred Seventy Only</Text>

      <View style={styles.bankDetails}>
        <Text style={{ fontWeight: "bold", marginBottom: 5 }}>Company's Bank Details</Text>
        <View style={styles.row}>
          <Text style={styles.label}>A/c Holder's Name</Text>
          <Text style={styles.colon}>:</Text>
          <Text>Rising Phoenix Print Hub LLP</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Bank Name</Text>
          <Text style={styles.colon}>:</Text>
          <Text>HDFC Bank A/c</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>A/c No.</Text>
          <Text style={styles.colon}>:</Text>
          <Text>50200054469412</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Branch & IFS Code</Text>
          <Text style={styles.colon}>:</Text>
          <Text>Sahakar Nagar & HDFC0000359</Text>
        </View>
      </View>

      <View style={styles.signatureBox}>
        <Text style={{ textAlign: "center", marginBottom: 40 }}>for Rising Phoenix Print Hub LLP</Text>
        <Text style={{ textAlign: "center" }}>Authorised Signatory</Text>
      </View>

      <Text style={styles.footer}>This is a Computer Generated Invoice</Text>
    </Page>
  </Document>
)

export default InvoicePDF

